import {writable} from "svelte/store";
import {loadMemories, MemoryManagerViewModel} from "./EndpointsAndTransforms";

const sessionMemories = writable([])

export const CacheLoadState = {
  loading: 'loading',
  found: 'found',
  failed: 'failed'
}

export function memory(uuid, stateCallback, dataC) {
  let cached = sessionMemories[uuid]
  if (cached != null) {
    dataC(cached)
    stateCallback(CacheLoadState.found)
  } else {
    stateCallback(CacheLoadState.loading)
    loadMemories(
      [uuid],
      (state) => {
      switch (state) {
        case MemoryManagerViewModel.loaded:
          stateCallback(CacheLoadState.found)
          break
        case MemoryManagerViewModel.error:
          stateCallback(CacheLoadState.failed)
          break
        }
      },
      (data) => {
        sessionMemories[uuid] = data[0]
        dataC(data[0])
      }
    )
  }
}

export function preFetchMemories(uuids, stateCallback) {
  stateCallback(CacheLoadState.loading)
  if (sessionMemories.length > 0) {
    stateCallback(CacheLoadState.found)
  } else {
    loadMemories(
      uuids,
      (state) => {
        switch (state) {
          case MemoryManagerViewModel.loaded:
            stateCallback(CacheLoadState.found)
            break
          case MemoryManagerViewModel.error:
            stateCallback(CacheLoadState.failed)
            break
        }
      },
      (data) => {
        data.forEach(memory => sessionMemories[memory['uuid']] = memory)
      }
    )
  }
}
